const Kategoriya2212 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 2-chorak<br />
                Mavzu: Tutuq belgisi haqida bilib olamiz <br />
“Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Tutuq belgisini to‘g‘ri qo‘yib, so‘zlarni yozing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘zlar imlosi ustida ishlash ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3 daqiqa <br />
            <p className="text-break">ananaviy - ________________________________________</p>
            <p className="text-break">mashala - _________________________________________</p>
            <p className="text-break">jurat - ____________________________________________</p>
            <p className="text-break">saroybon - _________________________________________</p>
            <p><b>2-mashq. Juftlikda ishlang. Tutuq belgili so‘zlarni qatnashtirib gaplar tuzing.</b></p>
            <p><i>Ta'limiy maqsad:</i>O‘quvchilarning gap ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa</p>
            <p>Bolalar … (mash’ala, gulxan, olov) ko‘tarib, musobaqani boshladilar.</p>
            <p>Onajonim, Sizga … (egilaman, ta’zim, xushomad) qilaman.</p>
            <p><b>3-mashq. FDM usuli asosida tutuq belgisi haqida fikr yuriting.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Dalil - _________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2212;